import { createReducer, on, Action } from '@ngrx/store';

import * as DrawerStateActions from './drawer-state.actions';
import { DrawerType, DrawerParms } from '@care-portals/api-interfaces';

export const DRAWERSTATE_FEATURE_KEY = 'drawerState';

export interface State {
  opening: boolean;
  error?: string | null; // last none error (if any)
  drawers: DrawerType[];
  popped: DrawerParms;
}

export interface DrawerStatePartialState {
  readonly [DRAWERSTATE_FEATURE_KEY]: State;
}

export const initialState: State = {
  // set initial required properties
  opening: false,
  drawers: [],
  popped: null
};

const drawerStateReducer = createReducer(
  initialState,
  on(DrawerStateActions.openDrawer, (state, { params }) => ({
    ...state,
    opening: true
  })),
  on(DrawerStateActions.openDrawerSuccess, (state, { drawerName }) => ({
    ...state,
    opening: false,
    drawers: [...state.drawers, drawerName],
    popped: null
  })),
  on(DrawerStateActions.openDrawerFailure, (state, { error }) => ({
    ...state,
    opening: false,
    error
  })),
  on(DrawerStateActions.closeDrawer, (state, { params }) => ({ ...state })),
  on(DrawerStateActions.closeDrawerSuccess, (state, { popped, drawers }) => ({
    ...state,
    popped,
    drawers
  })),
  on(DrawerStateActions.closeDrawerFailure, (state, { error }) => ({
    ...state,
    drawers: []
  }))
);

export function reducer(state: State | undefined, action: Action) {
  return drawerStateReducer(state, action);
}
